module.exports = __webpack_public_path__ + "img/aneme.d96f9611.png";